// extracted by mini-css-extract-plugin
module.exports = {"spinner":"LoadingSpinner_spinner__BXf1S","spin":"LoadingSpinner_spin__9HAoy"};